/* src/app/components/review/file-size-warning/file-size-warning.component.scss */
:host {
  overflow: auto;
}
table,
th,
td {
  border: 1px solid black;
}
table {
  width: 300px;
  color: darkgreen;
  align-self: center;
}
/*# sourceMappingURL=file-size-warning.component.css.map */
